import React, { useRef } from 'react';
import Invoice from './Invoice';
import styles from './Invoice.module.css';

function InvoicePreview({
  billedTo, date, invoiceNo, items, subtotal, cgst, sgst, totalWithTax,
  paymentInfo, footerNote, contact,
  logoUrl, signatureUrl,
}) {
  const invoiceRef = useRef(null);

  const handlePrint = () => {
    window.print();
  };

  return (
    <section className={styles['preview-card']}>
      <div className={styles['preview-header']}>
        <div className={styles['preview-label']}>📋 Invoice Preview</div>
        <button onClick={handlePrint} className={styles['print-btn']}>
          🖨️ Print Invoice
        </button>
      </div>
      <div ref={invoiceRef} className={styles['print-area']}>
        <Invoice
          billedTo={billedTo}
          date={date}
          invoiceNo={invoiceNo}
          items={items}
          subtotal={subtotal}
          cgst={cgst}
          sgst={sgst}
          totalWithTax={totalWithTax}
          paymentInfo={paymentInfo}
          footerNote={footerNote}
          contact={contact}
          logoUrl={logoUrl}
          signatureUrl={signatureUrl}
        />
      </div>
    </section>
  );
}

export default InvoicePreview;